import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {inject, Signal} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {NavigationService} from '../services/navigation.service';
import {User} from 'patja-api';
import {firstValueFrom} from 'rxjs';
import {REDIRECT_URL} from 'patja-ui';

export const loggedInGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService: AuthService = inject(AuthService);
  const navigationService: NavigationService = inject(NavigationService);

  if (authService.getStoredToken()) {
    const user: Signal<User | null> = await firstValueFrom(authService.getUser());

    if (user()) {
      return true;
    } else {
      navigationService.goToLogin();
      return false;
    }
  }
  // Save the redirect URL to session storage if the user is not logged in
  sessionStorage.setItem(REDIRECT_URL, state.url);
  navigationService.goToLogin();
  return false;
};
